<template>
  <div class="" v-html="html"></div>
</template>
<script>
import { getOrgIntro } from '@/api/system'
export default {
  name: '',
  data() {
    return {
      html: ''
    }
  },
  created() {
    this.getOrgIntroAsync()
  },
  methods: {
    async getOrgIntroAsync() {
      try {
        const res = await getOrgIntro()
        this.html = res
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
<style lang="less" scoped></style>
